import { useMedia } from 'react-use';

const useIsMobile = () => {
  const isMobile = useMedia('(max-width: 991.9px)', false);

  return isMobile;
};

export default useIsMobile;
